export const pathway = {
  finalize: 'Finalizuj',
  finalizeTitle: 'Finalizacja',
  prevStep: 'Poprzedni krok',
  nextStep: 'Następny krok',
  mail: 'Adres e-mail',
  configure: 'Konfiguruj',
  configureView: 'Zobacz szablon konfiguracji',
  return: 'Powrót',
  createNew: 'Utwórz nowy',
  finalizeDescription:
    'Na wskazany adres e-mail zostanie wysłany link do sfinalizowanego szablonu konfiguracji',
  finalizeRulesAccept: 'Akceptuję warunki',
  finalizeRules: 'regulaminu',
  mailRequired: 'E-mail jest wymagany',
  rulesRequired: 'Akceptacja regulaminu jest wymagana',
  summary: 'Podsumowanie',
  summaryButton: 'Podgląd',
  print: 'Drukuj',
  pendingChangesMessage:
    'Jeden z twoich wyborów powoduje konflikt z innymi. Rozwiąż je przed kontynuowaniem.',
  pendingChangesDetails: 'Możesz również cofnąć opcje powodujące konflikty.',
  details: 'Szczegoły',
  conflictOnSubmit: 'Nie możesz zapisać konfiguracji z powodu konfliktów.',
  packageConflictOnAccept:
    'Akceptacja pakietu spowodowała konflikty z Twoimi wybranymi opcjami.',
  notFoundDraft: 'Nie znaleziono takiego szablonu konfiguracji',
  loadingEditor: 'Ładowanie szablonu konfiguracji...',
  loadingProperties: 'Ładowanie właściwości podstawowych...',
  loadingModels: 'Pobieranie modeli...',
  simulationTitle: 'Symulacja dla szablonu konfiguracji: {config}',
  simulationPublishTitle: 'Publikowanie szablonu konfiguracji: {config}',
  simulationRefresh: 'Przeładuj',
  simulationRefreshTooltip: 'Przeładuj używane dane',
  simulationRulesRefresh: 'Odśwież reguły',
  simulationRulesRefreshTooltip:
    'Zastosuj nowe reguły bez ponownego ładowania modeli',
  simulationExistingTitle: 'Znaleziono aktywną symulację',
  simulationExistingDescription:
    'Możesz kontynuować istniejącą symulację albo rozpocząć nową (nadpisze poprzednią).',
  simulationContinueExisting: 'Kontynuuj istniejącą',
  simulationCreateNew: 'Rozpocznij nową',
  simulationStartedNew: 'Utworzono nową symulację.',
  simulationOutdatedConflict:
    'Symulacja była oparta o starszą wersję konfiguracji i została usunięta. Tworzę nową symulację.',
  violation: 'Naruszenie',
  simulationModels: 'Załadowanie modele w symulacji',
  simulationModel: 'Model',
  simulationModelsTime: 'Czas ładowania',
  simulationModelsSize: 'Rozmiar pliku',
  noSimulationModels: 'Nie załadowano żadnego modelu',
  swaps: {
    noChanges: 'Brak zmian',
    title:
      'Twoja ostatnia zmiana wymusiła zmiany w innych elementach szablonu konfiguracji',
    noAutomaticChanges:
      'Twoje ostatnie wybory nie spowodowały zadnych automatycznych zmian',
    optionAdded: 'Została dodana nowa opcja:',
    optionRemoved: 'Została usunięta opcja:',
    optionReplaced: 'Opcja',
    optionReplacedTo: 'została zamieniona na',
  },
  toolbox: {
    previewChanges: 'Podgląd zmian',
    previewChangesTooltip: 'Zobacz zmiany, które wykonały się automatycznie',
    packages: 'Pakiety',
    packagesNoNew: 'Pakiety (brak nowych do akceptacji)',
    packagesAvailableTitle: 'Pakiety',
    packagesAvailableDescription:
      'Masz dostępne pakiety opcji. Zaakceptuj aby zaaplikować wszystkie przypisane do niego opcje.',
    pendingPackagesPreview: 'Oczekujace pakiety:',
    packageConflictsTitle: 'Konflikty po zatwierdzeniu pakietu:',
    packageConflictsBlockingInfo:
      'Bez rozwiązania konfliktów nie można kontynuować pracy.',
    noPackagesToAccept: 'Brak pakietów dostępnych do akceptacji.',
    acceptPackage: 'Akceptuj',
    usedPackage: 'Użyty',
    usedPackageChangeWarning:
      '*Zmiana dowolnej opcji należącej do użytego pakietu spowoduje usunięcie tego pakietu.',
    camera: 'Kamera',
    fullscreen: 'Pełny ekran',
    rotate: 'Obracaj',
    resetCamera: 'Resetuj kamerę',
    scenery: 'Sceneria',
    background: 'Tło',
    goBackCamera: 'Poprzednia kamera',
  },
  localStorage: {
    info: 'Czy chcesz dokończyć utworzony już szablon konfiguracji?',
    edited: 'Edytowany',
    created: 'Utworzony',
    replace: 'Zastosuj',
    delete: 'Usuń',
  },
  conflicts: {
    dialogTitle: 'Szczegóły konfliktów w konfiguracji',
    dialogSubtitle:
      'Wykryto {count} konflikt | Wykryto {count} konflikty | Wykryto {count} konfliktów',
    noConflicts: 'Brak konfliktów do wyświetlenia',
    violationType: 'Typ naruszenia: {type}',
    traceDetails: 'Szczegóły ścieżki:',
    priority: 'Priorytet: {priority}',
  },
  controls: {
    notSupportedType: 'Nie obsługiwany typ kontrolki: {type}',
    noAvailableOption: 'Błąd konfiguracji (brak dostępnej opcji)',
  },
}
